import React from 'react';
import { FolderOpenIcon, EyeIcon, GuitarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const metrics = [{
  value: '240+',
  label: 'Stron do druku'
}, {
  value: '50',
  label: 'Gotowych ćwiczeń'
}, {
  value: '16',
  label: 'Tygodni planu'
}, {
  value: '3',
  label: 'Ścieżki poziomów'
}];
const coverage = ['Początkujący', 'Średniozaawansowany', 'Wyzwanie', 'Lekcje indywidualne', 'Lekcje grupowe'];
const steps = [{
  icon: FolderOpenIcon,
  title: 'Wchodzisz',
  text: 'Otwierasz tydzień, który masz dziś do przerobienia.'
}, {
  icon: EyeIcon,
  title: 'Patrzysz',
  text: 'Temat, ćwiczenie dla poziomu ucznia i teoria na jednej stronie.'
}, {
  icon: GuitarIcon,
  title: 'Uczysz',
  text: 'Drukujesz i wchodzisz na lekcję przygotowany.'
}];
export function Solution() {
  return <section aria-labelledby="solution-heading" className="bg-forest py-16 sm:py-24" data-id="element-215" data-mp="2c8336puon0l6">
      <div className="mx-auto max-w-shell px-5 sm:px-6" data-id="element-216" data-mp="2h7z76p3dqs0q">
        <SectionHeading id="solution-heading" eyebrow="Przedstawiamy" intro="Semestr gitary jazzowej zaplanowany tydzień po tygodniu, z ćwiczeniami i teorią gotowymi do użycia. Dla nauczycieli uczących prywatnie, w szkołach i studiach — także jeśli jazz nie jest Twoją specjalnością." data-id="element-217" data-mp="2h5cz8ockuahz">
          Arsenał Nauczyciela <span className="text-gold" data-id="element-218" data-mp="bqyuzwi7ryxn">Jazzu™</span>
        </SectionHeading>

        <dl className="mt-10 grid grid-cols-2 gap-3 sm:mt-12 lg:grid-cols-4 lg:gap-5" data-id="element-219" data-mp="3k7afxv9d2uxp">
          {metrics.map(metric => <div key={metric.label} className="rounded-xl border border-forest-soft bg-forest-deep px-4 py-6 text-center" data-id="element-220" data-mp="3g6gr8zo3hc3r">
              <dd className="font-display text-5xl font-extrabold leading-none text-gold" data-id="element-221" data-mp="3u69g0pg29i93">{metric.value}</dd>
              <dt className="mt-2 text-[11px] font-bold uppercase tracking-[0.14em] text-white/80" data-id="element-222" data-mp="3p4sgax9bc1u3">{metric.label}</dt>
            </div>)}
        </dl>

        <ul className="mt-6 flex flex-wrap justify-center gap-2" aria-label="Zakres" data-id="element-223" data-mp="14gxllwc2444f">
          {coverage.map(item => <li key={item} className="rounded-full border border-gold/40 px-3.5 py-1.5 text-xs font-semibold text-gold" data-id="element-224" data-mp="1cg2a2cybr70v">
              {item}
            </li>)}
        </ul>

        <ol className="mt-12 grid gap-3 sm:mt-16 lg:grid-cols-3 lg:gap-5" data-id="element-225" data-mp="1lijx2tlt03ox">
          {steps.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex items-center gap-4 rounded-2xl bg-white p-5 shadow-card-dark sm:p-6" data-id="element-226" data-mp="1qftscpvvj9ko">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-forest" data-id="element-227" data-mp="sr06upqshpdf">
                <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-228" data-mp="12r0uuozlstny" />
              </span>
              <div data-id="element-229" data-mp="12p7kozps7rb7">
                <h3 className="font-display text-2xl font-extrabold leading-none text-copy-dark" data-id="element-230" data-mp="17hha8emzipcy">{title}</h3>
                <p className="mt-1.5 text-sm leading-snug text-copy-muted" data-id="element-231" data-mp="a2va428jv4o4">{text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}